class ProductForm extends HTMLElement {
    constructor() {
        super();
        this.form = this.querySelector("form");
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cartNotification = document.querySelector("cart-notification");
    }

    onSubmitHandler(b) {
    b.preventDefault();
    this.cartNotification.setActiveElement(document.activeElement);

    let submitBtn = this.querySelector('[type="submit"]');
    submitBtn.setAttribute("disabled", true);
    submitBtn.classList.add("loading");

    //  Serialize form data first
    const formDataObject = JSON.parse(serializeForm(this.form));

    // Find hidden input for property (if exists)
    const hiddenInput = document.querySelector("#labdiamond-product");
    if (hiddenInput) {
        const inputName = hiddenInput.getAttribute("name"); // e.g. "properties[Ring Size]"
        const inputValue = hiddenInput.value;

        // Parse key from name → "Ring Size"
        const propertyKeyMatch = inputName.match(/properties\[(.+?)\]/);
        if (propertyKeyMatch) {
            const propertyKey = propertyKeyMatch[1];

            if (!formDataObject.properties) formDataObject.properties = {};
            formDataObject.properties[propertyKey] = inputValue;
        }
    }

    console.log("Sending form data with properties:", formDataObject);

    // Build payload
    let c = JSON.stringify({
        ...formDataObject,
        sections: this.cartNotification.getSectionsToRender().map((a) => a.id),
        sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig("javascript"), body: c })
        .then((a) => a.json())
        .then((a) => {
            const bundlesForm = document.querySelector(".bundles_form");
            const multibundleForm = document.querySelector(".bundles_form2");

            if (multibundleForm) {
                if ($(".bundles_metafield.bundle-2").val() == "0") {
                    this.submitBundlesForm(bundlesForm, a);
                } else {
                    this.submitBundlesForm(multibundleForm, a);
                }
            } else if (bundlesForm) {
                if ($(".bundle_variant-jtpl").val() == "0") {
                    this.cartNotification.renderContents(a);
                } else {
                    this.submitBundlesForm(bundlesForm, a);
                }
            } else {
                this.cartNotification.renderContents(a);
                console.log(a);
            }
        })
        .catch((a) => {
            console.error(a);
        })
        .finally(() => {
            submitBtn.classList.remove("loading");
            submitBtn.removeAttribute("disabled");
        });
}



    // Function to make sure hidden input is present
    ensureHiddenProperty() {
        const existingInput = this.form.querySelector("#labdiamond-product");
        if (!existingInput) {
            const hiddenInput = document.createElement("input");
            hiddenInput.type = "hidden";
            hiddenInput.id = "labdiamond-product";

            //  Customize this name & value according to Shopify settings
            hiddenInput.name = `properties[${window.sizeLabel || "Size"}]`; 
            hiddenInput.value = window.valueSize?.trim() || "Default Size";

            this.form.appendChild(hiddenInput);
            console.log("Hidden input added:", hiddenInput);
        }
    }

    submitBundlesForm(bundlesForm, initialData) {
        const bundlesFormData = new FormData(bundlesForm);

        fetch(`${routes.cart_add_url}`, {
            method: bundlesForm.method || "POST",
            body: bundlesFormData,
        })
            .then((response) => response.json())
            .then((bundleData) => {
                window.loadEgCartDrawer();
            })
            .catch((error) => {
                console.error("Error submitting bundles form:", error);
                window.loadEgCartDrawer();
            });
    }
}

customElements.define("product-form", ProductForm);
